$(document).on('change', '.js-product-select, .js-color-swatches', function () {
  let data = '';
  let color = $('.js-color-swatches .is-selected input').val();

  if (color) {
    data = data + `[data-color="${color}"]`;
  }

  $('.js-product-select').each(function () {
    const $this = $(this);
    let optionName = $this.data('name');
    let optionValue = $this.find('option:selected').val();

    data = data + `[data-${optionName}="${optionValue}"]`;
  });

  let finalValue = $(`.js-product-main-select option${data}`).val();

  if (finalValue) {
    $('.js-product-main-select').val(finalValue).change();
  }
});

$(document).on('change', '.js-product-main-select', function () {
  handleOptions(this);
});

if (!$('.js-list-selects li').length) {
  handleOptions(this);
}

function handleOptions(select) {
  const $this = $(select);
  const $price = $this.closest('.js-product').find('.js-product-price');
  const $button = $('.js-add-to-cart');
  const $quantity = $('.js-quantity');
  const $selectedOption = $this.find('option:selected');

  // Disable/Enable add to cart button
  if ($('.js-color-swatches input').length) {
    if ($('.js-color-swatches').find('input:checked').length) {
      if ($this.find(':selected').prop('disabled')) {
        $button.prop('disabled', true);
      } else {
        $button.prop('disabled', false);
      }

      // Remove initial button text
      $button.removeClass('is-initial');
    }
  } else {
    if ($this.find(':selected').prop('disabled')) {
      $button.prop('disabled', true);
    } else {
      $button.prop('disabled', false);
    }

    // Remove initial button text
    $button.removeClass('is-initial');
  }

  // Update product price
  $price.html($selectedOption.data('price-html'));

  // Update quantity field max value
  $quantity.find('input').attr('max', $selectedOption.data('inventory_quantity'));
}
